import { Link } from "react-router-dom";

export default function AboutQuote() {
  return (
    <>
      {/* Full-width quote image */}
      <section className="relative h-[65vh] min-h-[440px] overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/4dd9caf4ab17f6d5d1a06e5e045a9f6e.jpg"
          alt="Calm Spaces Journal philosophy"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/35" />
        <div className="absolute inset-0 flex items-center justify-center px-8">
          <div className="text-center max-w-3xl">
            <p
              className="text-white/50 text-5xl leading-none mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >&ldquo;</p>
            <blockquote
              className="text-white text-2xl md:text-4xl leading-snug italic"
              style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
            >
              The quieter the space, the richer the stillness within it.
            </blockquote>
            <p
              className="text-white/45 text-xs tracking-[0.4em] uppercase mt-6"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              — Calm Spaces Journal
            </p>
          </div>
        </div>
      </section>

      {/* CTA strip */}
      <section className="py-20 px-8 md:px-16 bg-[#FAF7F0]">
        <div className="max-w-screen-xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8">
          <div>
            <p
              className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-3"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Ready to explore?
            </p>
            <h3
              className="text-[#2C2825] text-2xl md:text-3xl"
              style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
            >
              Start finding your <em>calm spaces</em>
            </h3>
          </div>
          <div className="flex flex-wrap items-center gap-3">
            <Link
              to="/living-room"
              className="inline-flex items-center gap-2.5 bg-[#2C2825] text-[#FAF7F0] px-8 py-3.5 rounded-full text-xs tracking-[0.18em] hover:bg-[#3A3632] transition-colors cursor-pointer whitespace-nowrap uppercase"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Living Rooms
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs" />
              </span>
            </Link>
            <Link
              to="/cozy-corners"
              className="inline-flex items-center gap-2.5 border border-[#C8BAA8] text-[#6B5E53] px-8 py-3.5 rounded-full text-xs tracking-[0.18em] hover:bg-[#2C2825] hover:text-white hover:border-[#2C2825] transition-all duration-300 cursor-pointer whitespace-nowrap uppercase"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Cozy Corners
            </Link>
            <Link
              to="/style-guide"
              className="inline-flex items-center gap-2.5 border border-[#C8BAA8] text-[#6B5E53] px-8 py-3.5 rounded-full text-xs tracking-[0.18em] hover:bg-[#2C2825] hover:text-white hover:border-[#2C2825] transition-all duration-300 cursor-pointer whitespace-nowrap uppercase"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Style Guide
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
